import { render, staticRenderFns } from "./materialGRI.vue?vue&type=template&id=52d5bbaf&scoped=true"
import script from "./materialGRI.vue?vue&type=script&lang=js"
export * from "./materialGRI.vue?vue&type=script&lang=js"
import style0 from "./materialGRI.vue?vue&type=style&index=0&id=52d5bbaf&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d5bbaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d5bbaf')) {
      api.createRecord('52d5bbaf', component.options)
    } else {
      api.reload('52d5bbaf', component.options)
    }
    module.hot.accept("./materialGRI.vue?vue&type=template&id=52d5bbaf&scoped=true", function () {
      api.rerender('52d5bbaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/material/material-master-data/materialGRI.vue"
export default component.exports